import { useState } from 'react';
import { useDeleteReport } from '../analytics/useAnalytics';

/**
 * Custom hook to handle report deletion functionality
 * This hook encapsulates the state and handlers for deleting reports
 * to prevent code duplication across components
 */
export const useDeleteReportHandler = () => {
  const deleteReport = useDeleteReport();

  // State for delete confirmation dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [reportToDelete, setReportToDelete] = useState<string | null>(null);

  // Handle opening the delete confirmation dialog
  const handleDeleteClick = (reportId: string) => {
    setReportToDelete(reportId);
    setDeleteDialogOpen(true);
  };

  // Handle confirming deletion
  const handleConfirmDelete = () => {
    if (reportToDelete) {
      deleteReport.mutate(reportToDelete);
      setDeleteDialogOpen(false);
      setReportToDelete(null);
    }
  };

  // Handle canceling deletion
  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setReportToDelete(null);
  };

  return {
    deleteDialogOpen,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    isDeleting: deleteReport.isLoading,
  };
};
